var reader = new jsts.io.WKTReader()
var geometryFactory = new jsts.geom.GeometryFactory();

class Region
{
    contains(point) {
        let pointGeometry = geometryFactory.createPoint(new jsts.geom.Coordinate(point.x, point.y));

        return this.geometry.contains(pointGeometry);
    }
}

const emptyGeometry = reader.read("POLYGON EMPTY");

export class EmptyRegion extends Region
{
    constructor()
    {
        super();

        this.geometry = emptyGeometry;
    }
}

export class GeometryRegion extends Region
{
    constructor(tag, geometry)
    {
        super();

        this.tag = tag;
        this.geometry = geometry;
    }
}

export class ComputedRegion extends Region
{
    constructor(geometry)
    {
        super();

        this.geometry = geometry;
    }
}

class RegionStore
{
    constructor()
    {
        this.regions = {};

        this.createDemonstrationRegion("triangle", "POLYGON((100 100, 300 100, 200 300, 100 100))");
        this.createDemonstrationRegion("square", "POLYGON((200 200, 300 200, 300 300, 200 300, 200 200))");
        this.createDemonstrationRegion("rectangle", "POLYGON((50 150, 350 150, 350 250, 50 250, 50 150))");
    }

    createDemonstrationRegion(tag, wkt)
    {
        let region = new GeometryRegion(tag, reader.read(wkt));

        this.regions[region.tag] = region;
    }
}

export const defaultRegionStore = new RegionStore();
